// mockApi.ts
import MockAdapter from 'axios-mock-adapter';
import modulesUser from '../../cypress/fixtures/modules/modules-user.json';
import tags from '../../cypress/fixtures/tags/tags.json';
import tagsUser from '../../cypress/fixtures/tags/tags-user.json';
import notifications from '../../cypress/fixtures/notifications/notifications.json';
import calendar from '../../cypress/fixtures/home-screen/calendar.json';
import events from '../../cypress/fixtures/events/events.json';
import articlesHighlighted from '../../cypress/fixtures/home-screen/articles-highlighted.json';
import extremeEventUnseen from '../../cypress/fixtures/home-screen/extreme-event-unseen.json';
import articles from '../../cypress/fixtures/articles/articles.json';
import posts from '../../cypress/fixtures/posts/posts.json';
import similarArticles from '../../cypress/fixtures/articles/similar-articles.json';
import similarEvents from '../../cypress/fixtures/events/similar-events.json';
import { axiosInstance } from '../../client/axiosInstance';
import superAdmin from '../../cypress/fixtures/users/super-admin.json';
import birthdayToday from '../../cypress/fixtures/home-screen/birthday-today.json';
import helpdeskTopicsActive from '../../cypress/fixtures/helpdesk/topics-active.json';
import helpdeskOrganizationsActive from '../../cypress/fixtures/helpdesk/organizations-active.json';
import helpdeskIssuesSearch from '../../cypress/fixtures/helpdesk/issues-search.json';

export function setupMocks() {
  const mock = new MockAdapter(axiosInstance, { delayResponse: 200 });

  const notificationSeenIds = notifications?.flatMap((notification) => {
    return !notification.seen_at_utc ? [notification.id] : [];
  });

  mock.onGet('/extreme-event/unseen').reply(200, extremeEventUnseen);
  mock.onGet('/calendar').reply(200, calendar);
  mock.onGet('/articles/highlighted').reply(200, articlesHighlighted);

  mock.onGet('/modules/user').reply(200, modulesUser);
  mock.onPost('/modules/user/order').reply(200, {});
  mock.onGet('/tags').reply(200, tags);
  mock.onGet('/tags/user').reply(200, tagsUser);
  mock.onGet('/notifications').reply(200, notifications);
  mock.onGet(/\/events(\?.*)?$/).reply(200, events);
  mock.onGet(/\/articles(\?.*)?$/).reply(200, articles);

  mock.onGet('/users/me').reply(200, superAdmin);
  mock.onGet('/articles/similar').reply(200, similarArticles);
  mock.onGet('/events/similar').reply(200, similarEvents);

  mock.onGet('/posts/birthday/today').reply(200, birthdayToday);
  mock.onGet('/helpdesk/topics/active').reply(200, helpdeskTopicsActive);
  mock.onGet('/helpdesk/organizations/active').reply(200, helpdeskOrganizationsActive);
  mock.onGet('/helpdesk_issues/search').reply(200, helpdeskIssuesSearch);

  mock.onPost('/notifications/seen').reply(200, { ids: notificationSeenIds });
  mock.onPost('/tags').reply(200, null);
  mock.onPost('/tags/delete').reply(200, null);
  mock.onPost(/\/posts\/bookmarked\/\d+$/).reply(200, null);
  mock.onDelete(/\/posts\/bookmarked\/\d+$/).reply(200, null);

  mock.onGet(/\/posts\/\d+$/).reply((config) => {
    const match = config.url?.match(/\/posts\/(\d+)$/);
    const id = match ? parseInt(match[1], 10) : null;

    if (!id) {
      return [400, { message: 'Invalid post id' }];
    }

    const found = posts.items.find((item) => item.id === id);

    if (found) {
      return [200, found];
    }

    return [404, { message: `Post with id ${id} not found` }];
  });
}
